import {createContext} from "react"

const MediaContext =createContext();

export default MediaContext;